import { Component, EventEmitter, Input, OnDestroy, OnInit, Output, ViewChild, Inject, forwardRef, OnChanges, SimpleChanges } from '@angular/core';
import { SharedModule } from '@Shared/shared.module';
import { MatPaginator } from '@angular/material/paginator';
import { MatTableDataSource } from '@angular/material/table';

@Component({
    selector: 'users-selection-table',
    templateUrl: './users-selection-table.component.html',
    styleUrls: ['./users-selection-table.component.scss'],
    imports: [SharedModule]
})

export class UserSelectionTableComponent implements OnChanges {
    @ViewChild(MatPaginator) paginator: MatPaginator;

    @Input() users: any[] = [];
    @Input() label: string = '';
    @Input() selectedUsers: any[] = [];
    @Input() showError: boolean = false;
    @Output() selectionChange = new EventEmitter<any[]>();

    datasource = new MatTableDataSource<any>();

    tableColumns = ['select', 'username', 'role'];
    searchText: string = '';
    sortedUsers: any[] = [];

    ngOnChanges(changes: SimpleChanges): void {
        if (changes.selectedUsers) {
            const selectedIds = new Set((changes.selectedUsers.currentValue || []).map(u => u.id));
            this.users.forEach(u => u.selected = selectedIds.has(u.id));
        }

        if (changes.users && changes.users.currentValue) {
            this.sortedUsers = this.users.slice().sort((a, b) => {
                if (a.selected && !b.selected) return -1;
                if (!a.selected && b.selected) return 1;
                return a.name.localeCompare(b.name);
            });
        } else if (!this.sortedUsers.length) {
            this.sortedUsers = this.users.slice();
        }
        this.setData();
    }

    setData() {
        this.datasource.data = this.filteredUsers;
        this.datasource.paginator = this.paginator;
    }

    get filteredUsers() {
        let filtered = this.sortedUsers;
        if (this.searchText) {
            filtered = filtered.filter(u =>
                u.name.toLowerCase().includes(this.searchText.toLowerCase())
            );
        }
        return filtered;
    }

    onSelectionChange() {
        this.selectionChange.emit(this.users.filter(u => u.selected));
        this.setData();
    }
}